import { render, staticRenderFns } from "./DownloadXML.vue?vue&type=template&id=4df34bb5"
import script from "./DownloadXML.vue?vue&type=script&lang=js"
export * from "./DownloadXML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports